module.exports = __webpack_public_path__ + "static/media/messages_placeholder.91b452f1.svg";